import { fetchApi } from '@/common-utilities/fetch-utilities';
import type { Permission, PermissionsResponse } from '@/types/application/models/service/permission-model-responses';

export type { Permission } from '@/types/application/models/service/permission-model-responses';

/**
 * List all available permissions
 */
export async function listPermissions(): Promise<Permission[]> {
  const response = await fetchApi<PermissionsResponse>('/api/permissions');
  return response.data.permissions;
}

export default {
  listPermissions,
};

